import React from 'react'
import { CardSectionReason } from './CardSectionReason'

export const BackEndCourseReason = () => {
    return (
        <div className="flex flex-wrap px-8 md:px-16 pb-10">
                <div className='w-full flex flex-wrap  justify-center gap-x-8'>
                    <CardSectionReason order='1' title='Besarnya Gaji' descriptionBold='Rp 6.100.000 s.d Rp9.100.000' />
                    <CardSectionReason order="2" title="Besarnya Prospek Industri" descriptionNonBold='Industri yang terus diminati dan digunakan oleh seluruh kalangan masyarakat, terutama penggunaan website di internet' />
                    <CardSectionReason order='3' title='Banyaknya Lowongan Pekerjaan' descriptionBold='6.000.000+' subdescription='Lowongan Pekerjaan'/>
                </div>
            </div>
    )
}